import React, { ReactNode } from 'react'
import * as styles from './HeadingComponent.module.scss'
import { getClassNameFactory } from '../../utils/get-class-name-factory'

const getClassName = getClassNameFactory('Heading', styles)

export type HeadingProps = {
  children: ReactNode
  rank?: '1' | '2' | '3' | '4' | '5' | '6'
  size?: string
  color?: string
}

export const Heading = ({ children, rank, size, color }: HeadingProps) => {
  const Tag: any = rank ? `h${rank}` : 'span'

  return (
    <Tag className={getClassName()} style={{ fontSize: size, color }}>
      {children}
    </Tag>
  )
}
